import React from 'react'

import { Text } from '../../../components/presentation/Text'
import { useTabName, useSetTabByName } from '../../../components/tabs/TabsContext'
import Link from '../../../components/actions/Link'
import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'

const ViewSwitcher = () => {
  const { t } = useTranslation('session')
  const tab = useTabName()
  const setTab = useSetTabByName()
  if (!tab) return false

  const isOnLogin = tab === 'login'

  let label = t('viewSwitcher.wantToLogin')
  if (isOnLogin) label = t('forgotPasswordForm.forgotPassword')

  const onClick = () => (isOnLogin ? setTab('forgotPassword') : setTab('login'))

  return (
    <Link onClick={onClick}>
      <Text color={COLORS.dark3}>
        {label} <span style={{ color: COLORS.purple }}>{t('viewSwitcher.clickHere')}</span>
      </Text>
    </Link>
  )
}

export default ViewSwitcher
